module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itemsetting",
      "role": "tabpanel",
      "aria-labelledby": "item-tab"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h4 control-label",
    attrs: {
      "for": "formdescription"
    }
  }, [_vm._v("フォームの説明")]), _c('p', [_vm._v("入力したものが作成したフォーム上に表示されます。")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.form_description),
      expression: "form.form_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "formdescription",
      "rows": "3",
      "placeholder": "このフォームに対する説明を表示させたい場合に説明文を入力してください"
    },
    domProps: {
      "value": (_vm.form.form_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "form_description", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "form"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h5', [_vm._v("フォームエリア")]), _c('div', {
    staticClass: "form-area panel-group draganddrop",
    on: {
      "dragover": _vm.partDragOver,
      "drop": _vm.partDrop,
      "dragstart": _vm.dragStart
    }
  }, [_c('draggable', {
    attrs: {
      "options": {
        handle: ".sortHandle"
      }
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.form.item_list),
      callback: function($$v) {
        _vm.$set(_vm.form, "item_list", $$v)
      },
      expression: "form.item_list"
    }
  }, _vm._l((_vm.form.item_list), function(item, index) {
    return _c('itemDetail', {
      key: item.id,
      attrs: {
        "data": item,
        "index": index
      },
      on: {
        "update:data": function($event) {
          item = $event
        },
        "remove": function($event) {
          _vm.form.item_list.splice(index, 1)
        }
      }
    })
  }))], 1)]), _c('itemSource')], 1), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h4', [_vm._v("テーマカラー設定")]), _c('div', {
    staticClass: "input-group colorpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.theme_color),
      expression: "form.theme_color"
    }],
    staticClass: "form-control selectcolor",
    class: {
      invalid: _vm.$v.form.theme_color.$invalid
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.theme_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "theme_color", $event.target.value)
      }
    }
  }), _c('i', {
    staticClass: "fa fa-eyedropper input-group-addon",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.form.theme_color.$invalid),
      expression: "$v.form.theme_color.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.form.theme_color.colorcode),
      expression: "!$v.form.theme_color.colorcode"
    }]
  }, [_vm._v("カラーコードが正しくありません")])])]), _c('h4', [_vm._v("同意文設定")]), _c('div', {
    staticClass: "radio02"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.is_agree),
      expression: "form.is_agree"
    }],
    staticClass: "radio02-input",
    attrs: {
      "id": "radio02-01",
      "type": "radio",
      "name": "radio02",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.form.is_agree, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.form, "is_agree", "1")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "radio02-01"
    }
  }, [_vm._v("する")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.is_agree),
      expression: "form.is_agree"
    }],
    staticClass: "radio02-input",
    attrs: {
      "id": "radio02-02",
      "type": "radio",
      "name": "radio02",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.form.is_agree, "0")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.form, "is_agree", "0")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "radio02-02"
    }
  }, [_vm._v("しない")])])]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', [_vm._v("同意文")]), _c('div', {
    staticClass: "x_content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.agree_text),
      expression: "form.agree_text"
    }],
    staticClass: "summernote",
    class: {
      invalid: _vm.$v.form.agree_text && _vm.$v.form.agree_text.$invalid
    },
    domProps: {
      "value": (_vm.form.agree_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "agree_text", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.form.agree_text && _vm.$v.form.agree_text.$invalid),
      expression: "$v.form.agree_text && $v.form.agree_text.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.form.agree_text && !_vm.$v.form.agree_text.required),
      expression: "$v.form.agree_text && !$v.form.agree_text.required"
    }]
  }, [_vm._v("同意文は必須です")])])])]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "setting-button"
  }, [_c('a', {
    staticClass: "customsmallbutton btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保 存")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_vm._v("パーツ設定")]), _c('p', [_vm._v("パーツ一覧からパーツをドラッグ＆ドロップで、フォームエリアに移動してください。"), _c('br'), _vm._v("フォームエリアに移動後、クリックすると編集できます。ドラッグ＆ドロップすると上下移動で並び替えができます。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-426352a9","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/form/Item.vue
// module id = 599
// module chunks = 1